import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import BlogsTable from "../Blogs/BlogsTable";

const COPY = {
  title: "Manage Blogs",
  subtitle: "You Can View Edit & Delete Verified Blogs",
  searchPlaceholder: "Search Here",
};

const BlogsAdmin = () => {
  const { items, loading, searchValue, setSearchValue } =
    useAdminList("getBlogs");

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <BlogsTable driverData={items} />
    </AdminPage>
  );
};

export default BlogsAdmin;
